<template>
  <div v-if="data && data.items" :id="id" :class="className" :style="{ height: height, width: width }" />
  <div v-else :style="{ height: height, width: width, lineHeight: height }" style="text-align: center;color: #909399;font-size:0.8rem;">暂无数据</div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    range: {
      type: Number,
      default: 1
    },
    tagName: {
      type: String,
      default: '接收次数'
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
      showLabel: []
    }
  },
  watch: {
    data() {
      this.buildData()
    }
  },
  mounted() {
    this.buildData()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // 生成数据
    buildData() {
      var that = this
      if (!that.data || !that.data.items) {
        return
      }
      var doneValue1 = that.data.items[0].points

      var columLabel = [that.tagName]
      that.getTimeList(that.data.time_begin, that.data.time_end)
      var columName = that.showLabel
      var columnValue = []
      var arrData = []
      for (var i = 0; i < columLabel.length; i++) {
        arrData.push(doneValue1)
        // eslint-disable-next-line no-eval
        columnValue.push(eval('(' + ("{'name':'" + columLabel[i] + "','type':'line',smooth: true,'symbol': 'circle','symbolSize': 5," +
            "'showSymbol': false,'lineStyle': {'normal': { 'width': 1.3 }},'data':[" + arrData + ']}') + ')'))
        // columnValue.push(eval('(' + ("{'name':'" + columLabel[i] + "','type':'line','smooth': true,'symbol':'none','silent': true,'itemStyle': {normal: {lineStyle: {width:2}},emphasis: {lineStyle: {width:2}}},'data':[" + arrData + ']}') + ')'))
      }

      that.$nextTick(function() {
        that.buildChart(columLabel, columName, columnValue)
      })
    },
    // 生成图形
    buildChart(columLabel, columName, columnValue) {
      var that = this
      if (that.chart) {
        that.chart.dispose()// 销毁
      }
      that.chart = echarts.init(document.getElementById(that.id))

      var option = {
        // color: ['#68E6C1', '#fac858'],
        title: {
          text: '24小时统计',
          textStyle: {
            // 文字颜色
            color: '#9e9e9e',
            // 字体大小
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params, ticket, callback) {
            var htmlStr = '<div style="font-size: 12px;">';
            for (var i = 0; i < params.length; i++) {
              var param = params[i];
              var xName = param.name;// x轴的名称
              var seriesName = param.seriesName;// 图例名称
              var value = param.value;// y轴值
              if (i === 0) {
                htmlStr += xName + '<br/>';// x轴的名称
              }
              htmlStr += '';
              // 为了保证和原来的效果一样，这里自己实现了一个点的效果
              htmlStr += param.marker
              // 圆点后面显示的文本
              htmlStr += seriesName
              htmlStr += '<span style="font-size: 14px;color: #000;font-weight: bold;margin-left: 20px">' + that.$util.thousandSeparator(value) + '</span>';
              if (that.unit) {
                htmlStr += ' ' + that.unit
              }
            }
            htmlStr += '</div>';
            return htmlStr;
          }
        },
        legend: {
          // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
          orient: 'horizontal',
          // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: 'right',
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: 'top',
          icon: 'rect', // 形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 12, // 设置宽度
          itemHeight: 12, // 设置高度
          itemGap: 20, // 设置间距
          data: columLabel
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          min: 0,
          type: 'category',
          data: columName
        },
        yAxis: {
          min: 0,
          minInterval: 1,
          type: 'value'
          // ,
          // max: this.getMaxVal()
        },
        dataZoom: [{
          type: 'inside',
          start: 90,
          end: 100
        }],
        series: columnValue
      }

      that.chart.setOption(option)
    },
    getMaxVal() {
      var that = this
      var maxVal = 0
      if (that.data.maxValue) {
        maxVal = that.data.maxValue
      }
      maxVal += 1
      // 如果是单数
      if (maxVal % 2 !== 0) {
        maxVal += 1
      }
      if (maxVal < 4) {
        maxVal = 4
      }
      return maxVal
    },
    getTimeList(start, end) {
      var that = this
      if (!start || !end) {
        return
      }
      that.showLabel = []
      var format2 = 'MM-DD HH:mm'
      var startTime = that.$moment(start)
      var endTime = that.$moment(end)
      startTime = that.$moment(startTime).add(that.range, 'minutes');
      while (that.$moment(startTime).valueOf() <= that.$moment(endTime).valueOf()) {
        that.showLabel.push(that.$moment(startTime).format(format2))
        startTime = that.$moment(startTime).add(that.range, 'minutes');
      }
      return
    }
  }
}
</script>
